export default "__VITE_ASSET__DyMWjPXy__"